import styled from 'styled-components'

export const TriggerButton = styled.button`
  background-color: #ffffff;
  color: #223a5f;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
  font-family: 'Bree Serif';
`

export const PopupContainer = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  cursor: pointer;
`

export const RulesImage = styled.img`
  width: 100%;
  max-width: 600px;
`
